import { render } from "./NavLink.vue?vue&type=template&id=3247d5fc"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=3247d5fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__